module.exports = __webpack_public_path__ + "img/icon-adpixelpro.ee4c1de0.png";